import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as um from './util-misc.mjs'

export function isMaybeAuthed(ctx) {
  return a.truthy(ctx.env.getSessionId())
}

// Also see the server route `/auth/logout`.
export function logoutAndReload(ctx) {
  um.reqClientOnly()
  if (!c.DOM_AVAILABLE) return undefined

  clearAuthCookies()
  ctx.env.gtag.sendEvent(c.GTAG_EVENT_LOGOUT)
  ctx.env.dat.clear()
  return ctx.env.locPush(c.LINK_HOME)
}

function clearAuthCookies() {
  a.Cookie.delete(c.COOKIE_NAME_SESSION)
}

/*
Should be executed when initializing the app in SSR. As a fallback, this may
optionally be executed on the client. Note that in SSR, setting cookies via
`env.cook` causes us to append the header `set-cookie` for the response,
telling the browser to store the newly set cookie. See the class `SrvCookies`
and the method `Srv..res`.
*/
export function initDeviceId(env) {
  if (getDeviceId(env)) return
  env.cook.setVal(c.COOKIE_NAME_DEVICE_ID, a.uuid())
}

export function getDeviceId(env) {
  return a.only(env.cook.getVal(c.COOKIE_NAME_DEVICE_ID), isValidDeviceId)
}

/*
Reduced version of `db.constraint.device_id` in `cs-core`.
The full constraint also allows 64 hex digits, but `cs-front`
only uses 32-digit UUIDs for device id.
*/
function isValidDeviceId(val) {
  return a.isStr(val) && /^[0-9a-f]{32}$/.test(val)
}
